import React from 'react';
import WhatsappIcon from '../../assets/whatsapp-icon.png';
import { WHATSAPP_LINK } from '../../utils/constants';

const WhatsappFloatingButton = () => {
  const onWhatsappClick = () => {
    window.open(WHATSAPP_LINK, '_blank', 'noopener,noreferrer')
  }
  return (
    <img loading='lazy' onClick={onWhatsappClick} src={WhatsappIcon} alt="Whatsapp" style={{width: 50, position: 'fixed', right: 20, bottom: 20, cursor: 'pointer'}} />
  )
}

export default WhatsappFloatingButton